import { Graphics } from "pixi.js"
import { Coordinate } from "game-common/models"
import { ScalingParams } from "../../../../client_util"
import { lobHeight } from "./projectile_arc"

/** A trajectory snapshot may outlive the attack or entity that created it while fading. */
export class BombTrajectoryTracer extends Graphics {
    private origin?: Coordinate
    private target?: Coordinate
    private fadingAt?: number

    show = (origin: Coordinate, target: Coordinate) => {
        this.origin = { ...origin }
        this.target = { ...target }
        this.fadingAt = undefined
        this.alpha = 1
    }
    fade = (now = Date.now()) => {
        if (this.fadingAt === undefined) this.fadingAt = now
    }
    finished = (now = Date.now()) => !this.target ||
        this.fadingAt !== undefined && now - this.fadingAt >= 1000

    animate = (now = Date.now(), visible = true) => {
        this.clear()
        this.visible = visible && !this.finished(now)
        this.alpha = this.fadingAt === undefined ? 1 : Math.max(0, 1 - (now - this.fadingAt) / 1000)
        if (!this.visible || !this.target || !this.origin) return
        const scale = ScalingParams.surfaceZoom
        this.position.set(this.target.x * scale, this.target.y * scale)
        this.scale.set(scale)
        const dx = this.origin.x - this.target.x, dy = this.origin.y - this.target.y
        const count = Math.max(8, Math.min(64, Math.ceil((Math.hypot(dx, dy) + 80) / 10)))
        const phase = (now / 450) % 1
        this.lineStyle(0)
        this.beginFill(0xffdda1, 0.38)
        for (let i = 0; i < count; i++) {
            const progress = (i + phase) / count
            this.drawCircle(dx * (1 - progress), dy * (1 - progress) - lobHeight(progress) - 4, 1.5)
        }
        this.endFill()
    }
}
